class TrPriceRange extends HTMLElement {
	selectors = {
		minimumInput: '[data-tr-js-price-range-minimum]',
		maximumInput: '[data-tr-js-price-range-maximum]',
		minimumHiddenInput: '[data-tr-js-price-range-min-hidden]',
		maximumHiddenInput: '[data-tr-js-price-range-max-hidden]',
		minimumOutput: '[data-tr-js-price-range-min-output]',
		maximumOutput: '[data-tr-js-price-range-max-output]',
		progress: '[data-tr-js-price-range-progress]'
	};

	attributes = {};

	stateClasses = {};

	connectedCallback() {
		this.minimumInputElement = this.querySelector(this.selectors.minimumInput);
		this.maximumInputElement = this.querySelector(this.selectors.maximumInput);
		this.minimumHiddenInputElement = this.querySelector(this.selectors.minimumHiddenInput);
		this.maximumHiddenInputElement = this.querySelector(this.selectors.maximumHiddenInput);
		this.minimumOutputElement = this.querySelector(this.selectors.minimumOutput);
		this.maximumOutputElement = this.querySelector(this.selectors.maximumOutput);
		this.progressElement = this.querySelector(this.selectors.progress);

		this.init();
		this.bindEvents();

		document.addEventListener('shopify:section:load', this.onSectionLoad);
	}

	disconnectedCallback() {
		document.removeEventListener('shopify:section:load', this.onSectionLoad);

		this.destroy();
	}

	init() {
		this.minimumValue = Number(this.dataset.trJsPriceRangeMin || 0);
		this.maximumValue = Number(this.dataset.trJsPriceRangeMax || 0);
		this.currencyCode = this.dataset.trJsPriceRangeCurrencyCode || 'USD';

		this.update();
	}

	bindEvents() {
		if (this.minimumInputElement) {
			this.minimumInputElement.addEventListener('input', this.onRangeInput);
		}

		if (this.maximumInputElement) {
			this.maximumInputElement.addEventListener('input', this.onRangeInput);
		}
	}

	onRangeInput = (event) => {
		const minimumCurrentValue = Number(this.minimumInputElement.value);
		const maximumCurrentValue = Number(this.maximumInputElement.value);

		if (event.currentTarget === this.minimumInputElement && minimumCurrentValue > maximumCurrentValue) {
			this.minimumInputElement.value = maximumCurrentValue;
		}

		if (event.currentTarget === this.maximumInputElement && maximumCurrentValue < minimumCurrentValue) {
			this.maximumInputElement.value = minimumCurrentValue;
		}

		this.update();
	};

	onSectionLoad = (event) => {
		if (
			!this.closest(`#${event.detail.sectionId}`) &&
			!this.closest(`#shopify-section-${event.detail.sectionId}`)
		)
			return;

		this.init();
	};

	update() {
		if (!this.minimumInputElement || !this.maximumInputElement) return;

		const minimumCurrentValue = Number(this.minimumInputElement.value);
		const maximumCurrentValue = Number(this.maximumInputElement.value);
		const rangeSize = this.maximumValue - this.minimumValue;
		const progressLeft = rangeSize > 0 ? ((minimumCurrentValue - this.minimumValue) / rangeSize) * 100 : 0;
		const progressRight = rangeSize > 0 ? ((maximumCurrentValue - this.minimumValue) / rangeSize) * 100 : 100;

		this.style.setProperty('--trPriceRangeProgressLeft', `${progressLeft}%`);
		this.style.setProperty('--trPriceRangeProgressWidth', `${progressRight - progressLeft}%`);

		if (this.minimumOutputElement) {
			this.minimumOutputElement.textContent = this.formatMoney(minimumCurrentValue);
		}

		if (this.maximumOutputElement) {
			this.maximumOutputElement.textContent = this.formatMoney(maximumCurrentValue);
		}

		if (this.minimumHiddenInputElement) {
			this.minimumHiddenInputElement.value =
				minimumCurrentValue > this.minimumValue ? String(minimumCurrentValue) : '';
		}

		if (this.maximumHiddenInputElement) {
			this.maximumHiddenInputElement.value =
				maximumCurrentValue < this.maximumValue ? String(maximumCurrentValue) : '';
		}
	}

	formatMoney(value) {
		return new Intl.NumberFormat(document.documentElement.lang || 'en', {
			style: 'currency',
			currency: this.currencyCode,
			maximumFractionDigits: 0
		}).format(value);
	}

	destroy() {
		if (this.minimumInputElement) {
			this.minimumInputElement.removeEventListener('input', this.onRangeInput);
		}

		if (this.maximumInputElement) {
			this.maximumInputElement.removeEventListener('input', this.onRangeInput);
		}
	}
}

if (!customElements.get('tr-price-range')) {
	customElements.define('tr-price-range', TrPriceRange);
}
